import { Drawer, DrawerContent, DrawerDescription, DrawerTitle } from '@e2n/ui';
import { cn } from '@/lib/utils';
import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { useCreateTerminKalenderForm } from '@/domain/termine/features/CreateTerminKalender/shared/hooks/useCreateTerminKalenderForm';
import { CreateTerminKalenderDrawerForm } from '@/domain/termine/features/CreateTerminKalender/Drawer/CreateTerminKalenderDrawerForm';

type CreateTerminKalenderDrawerProps = {
  onOpenChange: (open: boolean) => void;
};

function CreateTerminKalenderDrawerFallback() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4 items-center justify-center text-sm">
      <FontAwesomeIcon
        icon={faSpinnerThird}
        className="text-primary-blue-200"
        spin
        size="4x"
      />
      {t('actions.loading')}
    </div>
  );
}

export function CreateTerminKalenderDrawer({
  onOpenChange,
}: CreateTerminKalenderDrawerProps) {
  const { t } = useTranslation();
  const form = useCreateTerminKalenderForm();

  const handleSubmitSuccess = () => {
    onOpenChange(false);
  };

  return (
    <Drawer
      repositionInputs={false}
      open
      onOpenChange={(open) => {
        if (!open) onOpenChange(false);
      }}
      dismissible>
      <DrawerContent
        showHandle={false}
        className={cn(
          'h-svh w-screen',
          'rounded-none border-0',
          'data-[vaul-drawer-direction=bottom]:mt-0',
          'data-[vaul-drawer-direction=bottom]:max-h-none',
          'data-[vaul-drawer-direction=bottom]:rounded-none',
          'data-[vaul-drawer-direction=bottom]:border-0',
        )}>
        <DrawerTitle className="sr-only">
          {t('domain.termine.kalender.form.neuerKalender')}
        </DrawerTitle>
        <DrawerDescription className="sr-only">
          {t('domain.termine.kalender.form.neuerKalender')}
        </DrawerDescription>
        <Suspense fallback={<CreateTerminKalenderDrawerFallback />}>
          <CreateTerminKalenderDrawerForm
            form={form}
            onSubmitSuccess={handleSubmitSuccess}
          />
        </Suspense>
      </DrawerContent>
    </Drawer>
  );
}
